var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconTooltip = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-24 -635) translate(24 635)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    className: "invert-light",
    d: "M16 22.667c.736 0 1.333.5971.333 1.333s-.597 1.333-1.333 1.333-1.333-.597-1.333-1.333.597-1.333 1.333-1.333zm0-16c2.946 0 5.333 2.387 5.333 5.333 0 2.485-1.7 4.573-4 5.165V19c0 .552-.447 1-1 1h-.666c-.553 0-1-.448-1-1v-3.333c0-.553.447-1 1-1H16c1.473 0 2.667-1.194 2.667-2.667 0-1.473-1.194-2.667-2.667-2.667-1.416 0-2.574 1.104-2.661 2.498l-.006.169c0 .736-.597 1.333-1.333 1.333s-1.333-.597-1.333-1.333c0-2.946 2.387-5.333 5.333-5.333z"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconTooltip);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-tooltip.c0aa4756b9e219b3935195882bfc738d.svg";